define('js/app',[
    "jquery",
    "mage/translate",
    "mage/url",
    "Axelites_Core/js/model/ax-core",
    "domReady!"
], function ($, $t, url, axCore) {

    function allowScroll() {
        $('body').addClass('scroll-mobile').removeClass('no-scroll-mobile');
    }

    function disallowScroll() {
        $('body').addClass('no-scroll-mobile').removeClass('scroll-mobile');
    }

    try {
        dataLayer.push({'event': 'optimize.activate'});
    } catch (e) {
    }
    $(document).ready(function () {

        if ($('.btn-top-headband').length > 0) {
            require(["jquery", "Magento_Ui/js/modal/modal"], function ($, modal) {
                $('#top-headband-content').modal({
                    autoOpen: false,
                    clickableOverlay: true,
                    innerScroll: true,
                    responsive: true,
                    modalClass: "top-headband-content",
                    type: 'popup',
                    modalClosedClass: 'modal-closed',
                    modalOpenedClass: 'modal-opened',
                    closed: function () {},
                    opened: function () {}
                });

                $(document).on('click', '.top-headband-content .action-close', function () {
                    $('#top-headband-content').modal('closeModal');
                });
                $(document).on('click', '.btn-top-headband', function(e) {
                    e.preventDefault();
                    $('#top-headband-content').removeClass('hidden');
                    $('#top-headband-content').css('display','flex');
                    $('.top-headband-content .modal-inner-wrap').css('width', '380px');
                    $('#top-headband-content').modal('openModal');
                });
            });

            var $topHeadband = $('#top-headband');
            $(window).scroll(function() {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > 52) {
                    $topHeadband.addClass('fixed');
                    $topHeadband.css('display', 'block');
                } else {
                    $topHeadband.removeClass('fixed');
                    $topHeadband.css('display', 'none');
                }
            });

        }
        $('.copy-btn').on('click', function () {
            var promoCode = $(this).attr('data-promo-code');
            var $btn = $(this);
            var $span = $btn.find('span');
            var originalText = $span.text();

            // Créer un input temporaire pour la copie
            var $tempInput = $('<input>');
            $('body').append($tempInput);
            $tempInput.val(promoCode).select();

            // Copier le texte
            document.execCommand('copy');
            $tempInput.remove();

            // Feedback visuel - ne modifier que le span
            $span.text($t('Copied !')
            );
            setTimeout(function () {
                $span.text(originalText);
            }, 2000);
        });

        if (typeof performance.getEntriesByType === 'function') {
            const entries = performance.getEntriesByType("navigation");

            // Vérifiez si des entrées de navigation sont disponibles
            if (entries.length > 0) {
                const entry = entries[0];

                // Effectuez des actions basées sur le type de navigation
                if (entry.type === "back_forward") {
                    if ($('.cms-home').length) {
                        setTimeout(function () {
                            $(document).trigger('scroll');
                        }, 500);
                    }
                }
            } else {
                console.log("Aucune entrée de navigation trouvée.");
            }
        } else {
            console.log("L'API performance.getEntriesByType n'est pas supportée dans ce navigateur.");
        }
        if (window.screen.width < 768 && $('.checkout-cart-index').length) {
            $(window).on('load', function () {
                try {
                    if (!elementInViewport2(document.querySelector('.checkout.checkout-methods-items .action.checkout'))) {
                        $(".mobile-total-order-bloc").css("display", "block");
                    }
                } catch (e) {
                    console.log(e)
                }
            });
            require(["jquery", "inView"], function ($) {
                $('.checkout.checkout-methods-items .action.checkout').on('inview', function (event, isInView) {
                    if (isInView) {
                        $(".mobile-total-order-bloc").css("display", "none");
                    } else {
                        $(".mobile-total-order-bloc").css("display", "block");
                    }
                });
            });
        }

        $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();
            if (window.screen.width < 768) {
                if ($('.page-with-filter').length) {
                    if (scroll > $('.footer').position().top) {
                        $('.cat-desc-mobile-actions').css('display', 'none');
                    } else {
                        $('.cat-desc-mobile-actions').css('display', 'flex');
                    }
                }
            }
            var topHeadband = $('#top-headband');
            var topFixedHeaderMobile = $('.action.nav-toggle');
            var topSearchHeader = $('.search-header');
            var topHeadbandHeight = topHeadband.length > 0 ? topHeadband.outerHeight() : 0;
            var topFixedFilter1  = topFixedHeaderMobile.length > 0 ? topFixedHeaderMobile.outerHeight() : 0;
            var topFixedFilter2  = topSearchHeader.length > 0 ? topSearchHeader.outerHeight() : 0;
            if (window.screen.width < 1025) {
                if (scroll >= 52) {
                    $(".header.content").addClass("fixedHeader").css("top", topHeadbandHeight + "px");
                    $(".page-main").addClass("fixed");
                    $(".fixed-filter").css("top", (topHeadbandHeight + topFixedFilter1 + topFixedFilter2 + 8) + "px");
                } else {
                    $(".header.content").removeClass("fixedHeader");
                    $(".header.content").css("top", 0);
                    $(".page-main").removeClass("fixed");
                }
            } else {
                if (scroll >=52) {
                    var pageHeaderHeight = $(".page-header").outerHeight();
                    // var heightFixedHeader = $(".fixedHeader").outerHeight();
                    var heightNavSection = $(".sections.nav-sections").outerHeight();
                    $(".page-header").addClass("fixed").css("top", topHeadbandHeight + "px");
                    $(".sections.nav-sections").addClass("fixed").css("top", (topHeadbandHeight + pageHeaderHeight) + "px");
                    $('.fixed-current-filter').css('top', (topHeadbandHeight + pageHeaderHeight + heightNavSection) + "px");
                } else {
                    $(".page-header").removeClass("fixed").css("top", "");
                    $(".sections.nav-sections").removeClass("fixed").css("top", "");
                }
            }
        });
        $(document).on('keyup', '#search', function (e) {
            if (e.which == 13 && ($(this).val().length >= 3)) {
                $(this).closest('form').submit();
            }
        });
        let isCategoryShowMoreClicked = false;
        $(".options li").on('keypress click', function (e) {
            e.preventDefault();
            let $this = $(this);
            if ($('body').hasClass('cms-soldes')) {
                $('.ais-ClearRefinements-button').trigger('click')
                if (!isCategoryShowMoreClicked) {
                    $('#ax_search_page .categories .ais-RefinementList-showMore').trigger('click');
                    isCategoryShowMoreClicked = true;
                }
                let mainCatId = $this.attr('data-cat-id');
                $('a[data-cat-id="' + mainCatId + '"]').closest('li').find('[data-cat-parentid="' + mainCatId + '"]').find('span').each(function () {
                    let $span = $(this);
                    if ($span.text() != '') {
                        $('#ax_search_page .categories .ais-RefinementList-item .ais-RefinementList-checkbox[value="' + $span.text() + '"]').trigger('click')
                    }
                });
            } else {
                document.location = $(this).attr('rel');
            }
        });

        topsubcategory()
        require(["jquery", "inView"], function ($) {
            if ($('.cms-index-index').length) {
                $('#review-section').one('inview', function (event, isInView) {
                    if (isInView) {
                        $(this).find('.customer-reviews').css('display', 'flex');
                    }
                });
            }
        });
        if ($('.product-popup').length > 0 || $('.product-shipping-popup').length > 0) {
            require(["jquery", "Magento_Ui/js/modal/modal"], function ($, modal) {
                $('#product-popup-wrapper').modal({
                    autoOpen: false,
                    clickableOverlay: false,
                    innerScroll: true,
                    responsive: true,
                    modalClass: "ax-product-popup-modal",
                    type: 'popup',
                    closed: function () {
                    },
                    opened: function () {
                    }
                });


                $(document).on('click', '.paiement-popup-trigger-show', function (e) {
                    e.preventDefault();

                    $('.cetelem-image').each(function (e) {
                        var src = $(this).attr('data-axsrc');
                        $(this).attr("src", src);
                    });
                    if (!$(this).attr('was-opened')) {
                        $('.ax-product-popup-modal .modal-inner-wrap').css('width', '800px');
                        $('#product-popup-wrapper').html($('#product-3x').html());
                        $(this).attr('was-opened', 1);
                    }
                    $('#product-popup-wrapper').modal("openModal");
                });

                $(document).on('click', '.scalapayLink', function (e) {
                    e.preventDefault();
                    $('.ax-product-popup-modal .modal-inner-wrap').css('width', '800px');
                    $('#product-popup-wrapper').html($('#scalapayModal').html());
                    $('#product-popup-wrapper').modal("openModal");
                });

                $(document).on("click touchstart", ".Sirv.thumb.product-popup .sirv-menzzo", function (e) {
                    $('.Sirv.thumb.product-popup').trigger('click');
                });

                $(document).on('click', '.product-popup', function (e) {
                    e.preventDefault();
                    var elem = $(this);
                    var content = null;

                    $('.ax-product-popup-modal .modal-inner-wrap').css('width', '800px');

                    if (elem.hasClass('3d-view-pop')) {
                        content = $('#3d-view').clone();
                        content.removeClass('hidden');
                    } else if (elem.hasClass('unpackage') || elem.hasClass('animation')) {
                        $('.ax-product-popup-modal .modal-inner-wrap').css('width', '860px');
                        var url = elem.data('pop');
                        url = url.replace('watch?v=', 'embed/');
                        content = $('<iframe width="100%" height="500" src="' + url + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
                    } else if (elem.hasClass('dimensions-produit')) {
                        content = $('<img src="' + $('#product-dimensions').data('pop') + '" />');
                    } else if (elem.hasClass('dimensions-colis')) {
                        content = $('<img src="' + $('#product-pack-dimensions').data('pop') + '" />');
                    } else if (elem.hasClass('pdf')) {
                        $('.ax-product-popup-modal .modal-inner-wrap').css('width', '850px');
                        content = $('<iframe width="100%" height="500" src="' + elem.data('pop') + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
                    }

                    $('#product-popup-wrapper').html(content);
                    $('#product-popup-wrapper').modal("openModal");
                });

                $(document).on('click', '.btn-plus-info-bedream-couches', function (e) {
                    e.preventDefault();
                    var src = $('#detais-matelas-image .img-details-bedream').attr('data-axsrc');
                    $("#detais-matelas-image .img-details-bedream").attr("src", src);
                    $('.ax-product-popup-modal .modal-inner-wrap').css('width', '800px');
                    $('#product-popup-wrapper').html($('#detais-matelas-image').html());
                    $('#product-popup-wrapper').modal("openModal");
                });
            });
        }
        /**** header phone number ***/
        $(document).on("click", ".phone-link", function (e) {
            e.stopPropagation();
            $(this).toggleClass('active');
        });
        $(document).on('click', function (e) {
            var container = $(".phone-link .phone-number-hidden");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.phone-link').removeClass('active');
            }
        });
        /********* language switcher ************/
        $(document).on("click", ".store-switcher-mobile", function (e) {
            e.stopPropagation();
            $(this).toggleClass('active');
        });

        $(document).on('click', function (e) {
            var container = $(".store-switcher-mobile");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.store-switcher-mobile').removeClass('active');
            }
        });
        /**** category description ***/
        $(document).on('click', '#btn-read-more', function (e) {
            e.preventDefault();
            $('.category-description.category-desc-hide').slideToggle();
            $(this).toggleClass('clicked');
        });
        /**** bedream product description ***/
        $(document).on('click', '.btn-compare-matelas-bedream', function () {
            $('.btn-voir-criteres').trigger('click');
            $('html, body').animate({
                scrollTop: $("#targetBedreamDiv").offset().top
            }, 2000);
        });
        $(document).on("click", ".btn-voir-criteres", function (e) {
            e.preventDefault();
            $('.hidden_row td').css('display', 'table-cell');
            $(this).addClass("btn-reduire-criteres");
            $(this).removeClass("btn-voir-criteres");
            $(this).html("Réduire le tableau");
        });
        $(document).on("click", ".btn-reduire-criteres", function (e) {
            e.preventDefault();
            $('.hidden_row td').css('display', 'none');
            $(this).addClass("btn-voir-criteres");
            $(this).removeClass("btn-reduire-criteres");
            $(this).html("Voir + de critères");
        });
        /** account-mobile**/
        $(document).on('click', '.account-link-mobile', function (e) {
            e.preventDefault();
            $('[data-action="toggle-nav"]').trigger('click');
            setTimeout(function() {
                $(".nav-sections-item-content .header.links")[0].scrollIntoView();
            }, 300);
        });

        /**** search mobile *****/
        $(document).on('click', '.search-link-mobile', function (e) {
            e.stopPropagation();
            var href = $(this).find(".sprite-svg-icon use").attr("xlink:href");
            if (href.includes('_black')) {
                var link = href.replace("icon_search_black", "close");
            } else {
                var link = href.replace("close", "icon_search_black");
            }
            $(this).find(".sprite-svg-icon use").attr("xlink:href", link);
            var $toggle = $(this).toggleClass("active");
            $(".search-mobile").toggleClass("active");
            $(".search-header").toggleClass("active");
            $('.search-header #search').focus();
            $('.search-header .ais-SearchBox-input').focus();
            if ($toggle.hasClass('active')) {
                axCore.CloseAllHeaderLinks('.search-link-mobile');
                var linksHtml = '';
                waitForElement('.klevu-pt-rs-keywords', function () {
                    $('.klevu-pt-rs-keywords a').each(function (index) {
                        var $this = $(this);
                        linksHtml += $('.klevu-pt-rs-keywords a')[index].outerHTML;
                    });
                    $('.klevu-pt-rs-keywords').html(linksHtml);
                    $('.klevu-searching-area').css('display', 'none');
                    $('.klevu-pt-rs-hover').css('display', 'block');
                });
            } else {
                $('.klevu-pt-rs-hover').css('display', 'none');
                $('.klevu-searching-area').css('display', 'none');
                $('#ax_search_popup').css('display', 'none');
            }
        });
        if ($(window).width() < 1024) {
            $(document).on('click', '.search-action-close', function (e) {
                $('#ax_search_popup').fadeOut();
            });
            $('.ais-SearchBox-input').on('input', function () {
                if ($(this).val().trim() !== '') {
                    $('.search-icon').css('display', 'none');
                    $('.close-icon').css('display', 'block');
                    disallowScroll();
                } else {
                    $('.search-icon').css('display', 'block');
                    $('.close-icon').css('display', 'none');
                    $('#ax_search_popup').css('display', 'none');
                    allowScroll();
                }
            });
            $('.close-icon').on('click', function () {
                $('.ais-SearchBox-input').val('');
                $('.search-icon').css('display', 'block');
                $('.close-icon').css('display', 'none');
                $('#ax_search_popup').css('display', 'none');
            });
        } else {

            var searchInput = $('.ais-SearchBox-input');
            // Function to update body classes
            function updateBodyClasses() {
                var navElement = $('.ax_search_popup_area');
                var isPopupVisible = navElement.length > 0 && navElement.is(':visible');
                var searchInput = $('.ais-SearchBox-input');
                var isSearchInputNotEmpty = searchInput.length > 0 && searchInput.val().trim() !== '';
                var isCatalogsearch = $('body').hasClass('catalogsearch-result-index');
                if (isPopupVisible || isSearchInputNotEmpty) {
                    $('body').addClass('no-scroll-mobile').removeClass('scroll-mobile');
                    $(document).ready(function () {
                        $('body').on('scroll', function () {
                            $(this).scrollTop(0); // Prevent vertical scrolling
                            $(this).scrollLeft(0); // Prevent horizontal scrolling
                        });
                    });
                } else {
                    $('body').addClass('scroll-mobile').removeClass('no-scroll-mobile');
                }
                if (isCatalogsearch) {
                    if (!isPopupVisible && isSearchInputNotEmpty) {
                        $('body').addClass('scroll-mobile').removeClass('no-scroll-mobile');
                    } else if (isPopupVisible && isSearchInputNotEmpty) {
                        $('body').addClass('no-scroll-mobile').removeClass('scroll-mobile');
                    }
                }
            }

            // Check if the popup is visible initially
            updateBodyClasses();

            // Event handlers
            $('.action.ais-SearchBox-form-submit').on('click', updateBodyClasses);
            searchInput.on('input keyup keydown', _.debounce(updateBodyClasses, 500));

            $(document).on('click', function (event) {
                if (!$(event.target).closest('.ax_search_popup_area').length) {
                    $('body').addClass('scroll-mobile').removeClass('no-scroll-mobile');
                }
            });
        }

        /******* category filter ********/
        $('.sort-mobile #sorter-mobile').on('change', function () {
            var value = $(this).val();
            $('.toolbar-sorter #sorter').val(value).trigger('change');
        });
        /******* cart mobile order button ********/
        $(document).on("click", ".mobile-action-primary-checkout", function (e) {
            e.preventDefault();
            $('.checkout-methods-items .action.primary.checkout').trigger('click');
        });
        /********Account dropDown*******/
        $(document).on('click', '.header-account-logout.account-links .account-label', function (e) {
            if ($(window).width() > 1024) {
                e.preventDefault();
                $('.header-account-logout.account-links ul.account-dropdown').toggleClass("open");
            }
        });
        $(document).on('click', function (e) {
            var container = $(".header-account-logout.account-links .account-label");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                $('.header-account-logout.account-links ul.account-dropdown').removeClass('open');
            }
        });
        /******header image-svg********/
        $(".svg-sprite-hover-red")
            .on("mouseover", function () {
                var href = $(this).find("use").attr("xlink:href");
                if (!href.includes('_red')) {
                    $(this).find("use").attr("xlink:href", href + "_red");
                }
            })
            .on("mouseout", function () {
                var href = $(this).find("use").attr("xlink:href");
                if (href.includes('_red') && !$(this).hasClass('active') && !$(this).hasClass('has-items')) {
                    var link = href.replace("_red", "");
                    $(this).find("use").attr("xlink:href", link);
                }
            });

        /*********product-zoom*******/
        if ($('.catalog-product-view').length > 0) {
            require(["jquery", "fotorama/fotorama"], function ($, fotorama) {
                $(document).on("click", ".fotorama__wrap--slide .fancy-loop", function (e) {
                    var fotorama = $('.fotorama').fotorama({allowfullscreen: true}).data('fotorama');
                    fotorama.requestFullScreen();
                    var $fotoramaDiv = $('.fotorama').fotorama();
                    $fotoramaDiv.data('fotorama').show(0);
                });
            });
            /********icon-Dispo-infos********/
            $(document).on("click", ".ax-price.info-price .product-availability.dispo-infos-open", function (e) {
                e.stopPropagation();
                $(this).closest('.product-availability').find('.dispo-infos').toggleClass('show');
            });
            $(document).on('click', function (e) {
                var container = $(".ax-price.info-price .product-availability.dispo-infos-open");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    container.closest('.product-availability.dispo-infos-open').find('.dispo-infos').removeClass('show');
                }
            });
            $(document).on("click", ".bloc-arrival .icon-infos-svg", function (e) {
                e.stopPropagation();
                $('.bloc-arrival .dispo-infos').toggleClass('show');
            });
            $(document).on('click', function (e) {
                var container = $(".bloc-arrival .icon-infos-svg");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    $('.bloc-arrival .dispo-infos').removeClass('show');
                }
            });
            if ($('.bloc-associated').length > 0) {
                calcColorisByProduct();
                $(document).on('click', '.show-more-product-colors-btn', function () {
                    $(this).find('.icn-color').attr('class', 'icn-color icn-minus');
                    $(this).attr('class', 'hide-more-product-colors-btn');
                    $('.product-color-wrap').css('overflow', 'visible');
                    $('.product-color-wrap').css('height', 'auto');
                });
                $(document).on('click', '.hide-more-product-colors-btn', function () {
                    $(this).find('.icn-color').attr('class', 'icn-color icn-plus');
                    $(this).attr('class', 'show-more-product-colors-btn');
                    $('.product-color-wrap').css('height', '27px');
                    $('.product-color-wrap').css('overflow', 'hidden');
                });
                require(["jquery", "Magento_Ui/js/modal/modal"], function ($, modal) {
                    $('#color-associated').modal({
                        autoOpen: false,
                        clickableOverlay: false,
                        innerScroll: true,
                        responsive: true,
                        modalClass: "ax-color-popup-associated-modal",
                        type: 'popup',
                        closed: function () {
                        },
                        opened: function () {
                        }
                    });
                    $(document).on('click', '.color-popup-associated', function (e) {
                        e.preventDefault();
                        $('#color-associated .modal-inner-wrap').css('width', '400px');
                        $('#color-associated').removeClass('hidden');
                        $('#color-associated').modal("openModal");
                    });
                    $(document).on('click', '.ax-product-associated .bloc-associated .title-bloc , .ax-product-associated .bloc-associated .link-infos', function (e) {
                        e.preventDefault();
                        var idProduct = $(this).attr('data-id');
                        $('#color-associated .modal-inner-wrap').css('width', '400px');
                        $('#color-associated').removeClass('hidden');
                        $('#color-associated').modal("openModal");
                        $('#product-other-color-' + idProduct)[0].scrollIntoView();
                    });
                });
            }
            /****product-page-new-design(sticky-price)****/
            var $set = $('#qty, #ax-qty')
            $set.change(function () {
                $set.not(this).val(this.value);
            });
            $(document).on('click', '#ax-product-addtocart-button', function (e) {
                e.preventDefault();
                $('#product-addtocart-button').trigger('click');
            });
        }
        if ($('.checkout-cart-index').length > 0) {
            require(["jquery", "Magento_Ui/js/modal/modal"], function ($, modal) {
                $('#cart-popup-wrapper').modal({
                    autoOpen: false,
                    clickableOverlay: false,
                    innerScroll: true,
                    responsive: true,
                    modalClass: "ax-product-popup-modal",
                    type: 'popup',
                    closed: function () {
                    },
                    opened: function () {
                    }
                });
                $(document).on('click', '#cart-total-paiement-popup-trigger', function (e) {
                    e.preventDefault();
                    $('.cetelem-image').each(function (e) {
                        var src = $(this).attr('data-axsrc');
                        $(this).attr("src", src);
                    });
                    $('.ax-product-popup-modal .modal-inner-wrap').css('width', '800px');
                    $('#cart-popup-wrapper').html($('#cart-total-3x').html());
                    $('#cart-popup-wrapper').modal("openModal");
                });
                $(document).on("click", "#cart-total-top-paiement-popup-trigger", function (e) {
                    e.preventDefault();
                    $('#cart-total-paiement-popup-trigger').trigger('click');
                });
                $('#promos-popup-wrapper').modal({
                    autoOpen: false,
                    clickableOverlay: false,
                    innerScroll: true,
                    responsive: true,
                    modalClass: "ax-product-popup-modal",
                    type: 'popup',
                    closed: function () {
                    },
                    opened: function () {
                    }
                });
                $(document).on("click", "#btn-show-promos", function (e) {
                    e.preventDefault();
                    $('.ax-product-popup-modal .modal-inner-wrap').css('width', '1000px');
                    $('#promos-popup-wrapper').html($('.modal-codes-promos').html());
                    $('#promos-popup-wrapper').modal("openModal");
                });
            });
        }
        /** recherche mobile**/
        $(document).on("click", ".field.search label", function (e) {
            $('form#search_mini_form').submit();
        });
        /** morelink homepage**/
        if ($(window).width() <= 767) {
            var maxHomeSeoTextHeight = 55;
            $('.home-center-box p').each(function (e) {
                if (parseInt($(this).css('height')) > 60) {
                    $(this).css({height: maxHomeSeoTextHeight, overflow: 'hidden'});
                    $(this).after($('<span class="morelink">' + $t('Read more') + '</span>').css('display', 'block'));
                }
            });
            $(document).on('click', '.morelink', function () {
                if ($(this).prev().hasClass('height-box')) {
                    $(this).prev().removeClass('height-box');
                    $(this).prev().css({height: maxHomeSeoTextHeight, overflow: 'hidden'});
                    $(this).text($t('Read more'));
                } else {
                    $(this).prev().addClass('height-box');
                    $(this).prev().css({height: '', overflow: ''});
                    $(this).text($t('Read less'));
                }
            });
        }
        /****scroll-mobile footer***/
        $(document).on('click', '.footer-scroll-mobile', function () {
            $(window).scrollTop(0);
        });
        /*** privacy policy footer-newsletter**/
        $(document).on('click', '.newsletter-wrap .block.newsletter .action.subscribe', function () {
            $(".newsletter-wrap .block.newsletter .field.newsletter label[for='newsletter']").find("#newsletter-error").remove();
            if ($('.check-menzzo-newsletter').length && $('.check-menzzo-newsletter input:checked').length == 0) {
                $(".newsletter-wrap .block.newsletter .field.newsletter label[for='newsletter']").append("<div id='newsletter-error' class='ax-newsletter-error'>" + $t('please check the Autorisation checkbox') + "</div>");
                $(".newsletter-wrap .block.newsletter .field.newsletter .ax-newsletter-error").fadeIn();
                setTimeout(function () {
                    $(".newsletter-wrap .block.newsletter .field.newsletter .ax-newsletter-error").fadeOut();
                }, 3500);
                return false;
            }
        });
        // Product Related Hover
        if ((!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) && ($(window).width() > 768)) {
            $(document).on("mouseenter", ".catalog-product-view .products-related a.product-item-photo", function () {
                this.t = this.title;
                this.title = "";
                var c = (this.t !== "") ? "<br/>" + this.t : "";
                var price = $(this).data('price');
                var img = $(this).data('image');
                var material = $(this).data('material');
                var availability = $(this).data('availability');
                var specialPrice = $(this).data('specialprice');
                var discount = $(this).data('discount');
                var regularprice = $(this).data('regularprice');
                var priceClass = ($(this).attr('data-specialPrice') ? "barred" : "price");
                var finalPrice = ($(this).attr('data-specialPrice') ? regularprice : price);
                var html = '';
                var html = '<div id="pop-prod-preview">';
                html += '<img src="' + img + '" alt="Image preview" />';
                html += '<span>' + $t('Dispo') + '<span>' + availability + '</span></span>';
                html += '<span>' + $t('Material') + '<span>' + material + '</span></span>';
                html += '<span class="price-wrapper">';
                html += '<span class="' + priceClass + '">' + finalPrice + '</span>';
                if (specialPrice && discount) {
                    html += '<span class="discount-poucentage">-' + discount + '</span><span class="special-price">' + specialPrice + '</span>';
                }
                html += '</span>';
                html += '</div>';
                $(this).closest('li').append(html);
                $("#pop-prod-preview")
                    .fadeIn("fast");
            });
            $(document).on("mouseleave", ".catalog-product-view .products-related a.product-item-photo", function () {
                $("#pop-prod-preview").remove();
            });
        }
        /************/
        // Product Express Chrono
        if ($('#chrono-express').length > 0) {
            $('body').addClass('chrono-express-active');
            require(["jquery", "js/jquery.countdown.min"], function ($, countdown) {
                $('#time').countdown(chrono_limit, function (event) {
                    var template = chrono_format;
                    var totalHours = event.offset.totalDays * 24 + event.offset.hours;
                    var totalMinutes = event.offset.minutes;
                    var totalSeconds = event.offset.seconds;
                    template = template.replace('{H}', totalHours);
                    template = template.replace('{M}', totalMinutes);
                    template = template.replace('{S}', totalSeconds);
                    $(this).html(template);
                });

                $('#mctime').countdown(chrono_limit, function (event) {
                    var template = chrono_format;
                    var totalHours = event.offset.totalDays * 24 + event.offset.hours;
                    var totalMinutes = event.offset.minutes;
                    var totalSeconds = event.offset.seconds;
                    template = template.replace('{H}', totalHours);
                    template = template.replace('{M}', totalMinutes);
                    template = template.replace('{S}', totalSeconds);
                    $(this).html(template);
                });
            });
        }
        if ($('#pb-color-container').length > 0) {
            $(document).on('click', '#pb-color-container button', function (e) {
                $('#pb-color-container').toggleClass('open');
            });

            $(document).on('click', '#pb-color-select a', function (e) {
                e.preventDefault();
                $('#pb-color-container button').html($(this).html()).append("<span class='caret'></span>");
                window.location.href = $(this).attr('href');
            });
        }


        if ($('.onestepcheckout-index-index').length > 0) {

            $(document).on("click", "input[id^='s_method']", function () {
                toggleShippingMethodDescription();
            });

            $(document).on("click", ".table-checkout-shipping-method tr", function () {
                toggleShippingMethodDescription();
            });
            $(document).on('click', '.payment-method .payment-method-logo', function () {
                $(this).closest('.payment-method').find('.payment-method-radio').trigger('click');
            });

            $(document).on('click', '#ax-checkout-authentication', function () {
                $(".osc-authentication-wrapper .a.action.ax-social-login-btn").trigger('click');
            });

            $(document).on('click', '.payment-method-content input:radio', function () {
                var current = $(this).attr('name') + '_' + $(this).val();
                if ($(this).closest('.payment-method-content').hasClass('payment-method-floa')) {
                    var phoneNumber = "";
                    var floaMethod = $(this).val();
                    if ($('#shipping input[name="telephone"]').val() != "") {
                        phoneNumber = $('#shipping input[name="telephone"]').val();
                    } else if ($('#billing input[name="telephone"]').val() != "") {
                        phoneNumber = $('#billing input[name="telephone"]').val();
                    }
                    if (phoneNumber != "") {
                        $('#' + floaMethod + '_phone_number').val(phoneNumber);
                    }
                }

                $('.payment-method-content input:radio:checked').each(function () {
                    if ($(this).attr('name') + '_' + $(this).val() != current) {
                        $(this).prop("checked", false);
                    }
                });
                $('.payment-method-content select').val('');
                $(this).closest('.payment-method')
                    .find('.payment-method-title')
                    .first()
                    .find('input:radio')
                    .first()
                    .trigger('click');
            });

            $(document).on('click', '.payment-method input:radio', function () {
                const $currentRadio = $(this);
                const current = $currentRadio.attr('name') + '_' + $currentRadio.val();

                if ($currentRadio.val() !== "payline_web_payment_cpt") {
                    $('.payment-method-content input:radio:checked').not($currentRadio).prop("checked", false);
                }
            });


            $(document).on('change', '.payment-method-content > select', function () {
                var current = $(this).attr('name') + '_' + $(this).val();
                $('.payment-method-content input:radio:checked').each(function () {
                    if ($(this).attr('name') + '_' + $(this).val() != current) {
                        $(this).prop("checked", false);
                    }
                });

                $(this).closest('.payment-method')
                    .find('.payment-method-title')
                    .first()
                    .find('input:radio')
                    .first()
                    .trigger('click');
            });
        }
        require(['ko'], function (ko) {//don't remove ko we need it to exist in page before we run those functions
            $(document).on("click", "a.action.ax-social-login-btn", function (event, fromAppJs = null) {
                loadSocialLogin(() => {
                    if (null === fromAppJs) {
                        fromAppJs = 1;
                        $('a[href*="customer/account/login"]').trigger('click', [fromAppJs]);
                    }
                });
            });

            $('a[href*="customer/account/login"], .authorization-link:not(.logout) a').prop('href', '#').on('click', function (event, fromAppJs = null) {
                if ($('.authorization-link.logout a').length) {
                    return;
                }
                loadSocialLogin(() => {
                    if (null === fromAppJs) {
                        fromAppJs = 1;
                        $('a[href*="customer/account/login"]').trigger('click', [fromAppJs]);
                    }
                });
            });
            if (!$('body').hasClass('customer-account-login')) {
                $('a[href*="customer/account/create"]').prop('href', '#').on('click', function (event, fromAppJs = null) {
                    loadSocialLogin(() => {
                        if (null === fromAppJs) {
                            fromAppJs = 1;
                            $('a[href*="customer/account/create"]').trigger('click', [fromAppJs]);
                        }
                    });
                });
            }

            $('a[href*="customer/account/logout"], .authorization-link.logout a').prop('href', '#').on('click', function (event, fromAppJs = null) {
                $(this).removeAttr('data-post', '');
                loadSocialLogin(() => {
                    if (null === fromAppJs) {
                        fromAppJs = 1;
                        $('a[href*="customer/account/logout"], .authorization-link.logout a').trigger('click', [fromAppJs]);
                    }
                });
            });

            $('[data-role="proceed-to-checkout"]').prop('href', '#').on('click', function (event, fromAppJs = null) {
                loadSocialLogin(() => {
                    if (null === fromAppJs) {
                        fromAppJs = 1;
                        $(this).trigger('click', [fromAppJs]);
                    }
                });
            });
        });


        $(document).on("click", ".content-right button.btn-red", function (e) {
            e.preventDefault();
            $(this).addClass("focus");
            setTimeout(function () {
                $(this).removeClass("focus");
            }, 300);
        });



        /** avis client photo modal **/
        if ($('.zoompicture').length > 0) {
            const typesenseConfig = typesense_config_data.typesenseConfig;
            const storeId = typesense_config_data.storeId;
            var catId = 383;
            require(["jquery", "Magento_Ui/js/modal/modal"], function ($, modal) {
                var zoomModal = $('<div/>', {
                    id: 'home-img-zoom',
                });
                $('body').append(zoomModal);
                zoomModal.modal({
                    autoOpen: false,
                    clickableOverlay: true,
                    innerScroll: true,
                    responsive: true,
                    modalClass: "home-img-zoom",
                    type: 'popup',
                    closed: function () {
                    },
                    opened: function () {
                    }
                });

                $(document).on('click', '.zoompicture', function (e) {
                    let images = $(this).attr('data-preview');
                    var id = $(this).attr('data-product-id');

                    e.preventDefault();
                    if(id){
                        var settings = {
                            "url": "https://" + typesenseConfig.host_name + "/collections/" + typesenseConfig.prefix + "_products_" + storeId + "_category_" + catId + "/documents/search?q=*&query_by=product_id&filter_by=product_id:=" + id,
                            "method": "GET",
                            "timeout": 0,
                            "headers": {
                                "X-TYPESENSE-API-KEY": typesenseConfig.api_key
                            },
                        };
                        $.ajax(settings).done(function (response) {
                            if (response.found != 0) {
                                var product = response.hits[0].document;
                                var html = generateReviewPopupHtml(images, product);
                                zoomModal.html(html);
                                swiperClientsReviewImagesInitialize();
                                zoomModal.modal("openModal");
                            } else {
                                var html = generateReviewImagePopupHtml(images);
                                zoomModal.html(html);
                                zoomModal.modal("openModal");
                            }
                        });
                    } else {
                        var html = generateReviewImagePopupHtml(images);
                        zoomModal.html(html);
                        zoomModal.modal("openModal");
                    }

                });


            })
        }


        /*****
         * avis client photo popup
         */
        $(document).on('click', '.ax-show-more-photo', function (e) {
            e.preventDefault();
            var $this = $(this);
            $(this).attr("disabled", "disabled");
            let imageDivElement = $(this).closest('.ax-reviews-images').find('.inner-partagedeco.visible').last();
            let imageDivElementId = imageDivElement.attr('id');
            let key = imageDivElementId.replace("deco-image-", "");
            let nextKey = parseInt(key) + 1;
            $.when($.ajax({
                url: url.build('all-reviews/index/images'),
                type: 'post',
                data: {
                    key: nextKey,
                    page: 'home',
                    isMobile: mobileAndTabletCheck()
                }
            })).then((response) => {
                if (response) {
                    $this.closest('.ax-reviews-images').find('.inner-partagedeco-wrap').append(response);
                    let commentsDivEmenet = $(this).closest('#review-section').find('.bloc-review .infinite-review');
                    let commentsHeight = commentsDivEmenet.outerHeight() + imageDivElement.outerHeight();
                    if ($(window).width() > 767) {
                        commentsDivEmenet.css('height', commentsHeight + 'px');
                    }
                    $this.removeAttr('disabled');
                } else {
                    window.location.href = '/all-reviews';
                }

            });
        });

        $('.catalog-product-view .ax-product-sticky-price button.tocart').on('click', function() {
            if ($(window).width() <= 768) { // seulement sur mobile
                var $btn = $(this);
                $btn.addClass('clicked');

                // optionnel : retirer la classe après un moment
                setTimeout(function() {
                    $btn.removeClass('clicked');
                }, 10000); // après 5 secondes
            }
        });

    });

    $(document).ready(function () {
        var popup = $('#review-popup-wrapper');

        if (popup.length) {
            var options = {
                autoOpen: false,
                clickableOverlay: true,
                innerScroll: true,
                responsive: true,
                modalClass: "ax-product-reviews-popup-modal",
                type: 'popup',
                closed: function () {},
                opened: function () {}
            };

            popup.modal(options);

            $(document).on('click', '.link-reviews', function (e) {
                e.preventDefault();
                $('.ax-product-reviews-popup-modal .modal-inner-wrap').css('width', '450px');
                popup.modal('openModal');
            });

            $(document).on('click', '.ax-product-reviews-popup-modal .action-close', function () {
                popup.modal('closeModal');
            });
        }
    });
    $(document).ready(function () {
        var popupShipping = $('#product-shipping');

        if (popupShipping.length) {
            var options = {
                autoOpen: false,
                clickableOverlay: true,
                innerScroll: true,
                responsive: true,
                modalClass: "ax-product-shipping-popup-modal",
                type: 'popup',
                closed: function () {},
                opened: function () {}
            };

            popupShipping.modal(options);

            $(document).on('click', '.product-shipping-popup', function (e) {
                e.preventDefault();
                $('.ax-product-shipping-popup-modal .modal-inner-wrap').css('width', '800px');
                popupShipping.html($('#product-shipping').html());
                $('#product-shipping').addClass('force-display-block');
                popupShipping.modal("openModal");
            });

            $(document).on('click', '.ax-product-shipping-popup-modal .action-close', function () {
                popupShipping.modal('closeModal');
            });
        }

        require(['mage/url'], function (urlBuilder) {
            $(document).on('focus', '#searchbox .ais-SearchBox-input', function (e) {
                e.preventDefault();
                if(!$('#ax_search_popup').length) {
                    $.when($.ajax({
                        url: urlBuilder.build('axelites_core/ajaxloadcontent/init'),
                        type: 'post',
                        data: {
                            typesenseArea: 'typesense-popup',
                            isMobile: mobileAndTabletCheck()
                        }
                    })).then((response) => {
                        if (response) {
                            $('body .page-footer').after(response);
                            $('#ax_search_popup').trigger('contentUpdated');
                        }

                    });
                }
            });
        });


        $('.ais-SearchBox-input').on('input', function () {
            if ($(this).val().trim() !== '') {
                $('.search-icon').hide();
                $('.close-icon').show();
            } else {
                $('.search-icon').show();
                $('.close-icon').hide();
            }
        });

            $('.close-icon').on('click', function () {
                $('.ais-SearchBox-input').val('');
                $('.search-icon').show();
                $('.close-icon').hide();
            });

    });

    window.mobileAndTabletCheck = function () {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    };

    function topsubcategory() {
        if ($('.carousel-Topsubcategory').length) {
            require(['require', 'jquery', 'flickity'], function (require, $, Flickity) {
                var carouselTopsubcategory = new Flickity('.carousel-Topsubcategory', {
                    cellAlign: 'left',
                    pageDots: false,
                    prevNextButtons: false,
                    lazyLoad: 1,
                    freeScroll: true,
                    contain: true,
                    on: {
                        // Event handler for when Flickity is initialized
                        ready: function() {
                            this.resize()
                        }
                    }
                });
                return carouselTopsubcategory;
            });

        }
    }

    /**
     *  Get swiper slide html
     * @param product
     * @param cssClass
     * @param imgWidth
     * @returns {string}
     */
    function getSwiperSlideHtml(hidePromoOldPrice, product, lazyLoading = '', cssClass = 'col-md-3 col-12 item-product', imgWidth = 288, imgHeight = 288) {
        var discountClass = "";
        if (product.ax_display_promo) {
            discountClass = "ax-special-price discount-29";
        }
        var priceHtml = `<span class="price ${discountClass}" >${product.price}</span>`;
        if (product.has_special_price) {
            if (hidePromoOldPrice == 1 || parseInt(product.discount) <= 5) {
                if (parseInt(product.discount) >= 29 || true) {
                    discountClass = "ax-special-price discount-29"
                }
                priceHtml = `<span class="${discountClass}" >${product.special_price}</span>`;
            } else if (hidePromoOldPrice == 0 && parseInt(product.discount) > 5) {

                const hideDiscountPercentOnPromoTag = typeof typesense_config_data.hideDiscountPercentOnPromoTag !== "undefined" ? typesense_config_data.hideDiscountPercentOnPromoTag : 0;

                priceHtml = `
                      <span class="line-through">${product.regular_price}</span>`;

                if (!(product.solde_label && product.solde_label === "PROMO" && hideDiscountPercentOnPromoTag)) {
                    priceHtml += `<span class="btn-promo">-${product.discount}</span>`;
                }

                priceHtml += `<span class="price-promo">${product.special_price}</span>`;
            }
        }
        var isBlackFridayHtml = '';
        // if(product.is_black_friday){
        //     isBlackFridayHtml = `<div class='mz-black-fridy'>${$t('Crazy prices')}</div>`;
        // }

        if (typeof product.solde_label !== "undefined" && product.solde_label) {
            isBlackFridayHtml = `<div class='mz-black-fridy'>${$t(product.solde_label)}</div>`;
        }

        return `<div class="swiper-slide ${cssClass}">
                    <a class="item-image" href="${product.url}">
                        <div class="img-product justify-content-center align-items-center">
                            <picture>
                                <source srcset="${appendParameter(product.img, 'fm=webp')}" type="image/webp">
                                <img ${lazyLoading} src='${product.img}' alt='${product.name}' width='${imgWidth}' height='${imgHeight}'/>
                            </picture>
                        </div>
                        ${isBlackFridayHtml}
                        <div class="item-content item-content-gris text-center">
                            <div class="item-price">
                             ${priceHtml}
                            </div>
                            <h3 class="item-title">${product.name}</h3>
                        </div>
                    </a>
                </div>`;
    }

    function getSwiperSlideHtmlBestSellers(hidePromoOldPrice, product, cssClass = 'col-md-3 col-12 item-product', imgWidth = 288, imgHeight = 288) {
        var discountClass = "";
        if (product.ax_display_promo) {
            discountClass = "ax-special-price discount-29";
        }
        var priceHtml = `<span class="price ${discountClass}">${product.price}</span>`;
        if (product.has_special_price) {
            if (hidePromoOldPrice == 1 || parseInt(product.discount) <= 5) {
                if (parseInt(product.discount) >= 29 || true) {
                    discountClass = "ax-special-price discount-29"
                }
                priceHtml = `<span class=" ${discountClass}">${product.special_price}</span>`;
            } else if (hidePromoOldPrice == 0 && parseInt(product.discount) > 5) {

                const hideDiscountPercentOnPromoTag = typeof typesense_config_data.hideDiscountPercentOnPromoTag !== "undefined" ? typesense_config_data.hideDiscountPercentOnPromoTag : 0;

                priceHtml = `<span class="line-through">${product.regular_price}</span>`;

                if (!(product.solde_label && product.solde_label === "PROMO" && hideDiscountPercentOnPromoTag)) {
                    priceHtml += `<span class="btn-promo">-${product.discount}</span>`;
                }

                priceHtml += `<span class="price-promo">${product.special_price}</span>`;
            }
        }
        var isBlackFridayHtml = '';
        // if(product.is_black_friday){
        //     isBlackFridayHtml = `<div class='mz-black-fridy'>${$t('Crazy prices')}</div>`;
        // }
        if (typeof product.solde_label !== "undefined" && product.solde_label) {
            isBlackFridayHtml = `<div class='mz-black-fridy'>${$t(product.solde_label)}</div>`;
        }
        return `<div class="swiper-slide ${cssClass}">
                    <a class="item-image" href="${product.url}">
                        <div class="img-product justify-content-center align-items-center">
                            <picture>
                                <source srcset="${appendParameter(product.img, 'fm=webp')}" type="image/webp">
                                <img loading="lazy" src='${product.img}' alt='${product.name}' width='${imgWidth}' height='${imgHeight}'/>
                            </picture>
                        </div>
                        ${isBlackFridayHtml}
                        <div class="item-content item-content-gris text-center">
                            <div class="item-title">${product.label}</div>
                            <div class="item-price">
                             ${priceHtml}
                            </div>
                        </div>
                    </a>
                </div>`;
    }

    var showDescription = null;


    function initToggleShippingMethodDescription() {
        if ($('.table-checkout-shipping-method').length > 0) {
            clearInterval(showDescription);
            toggleShippingMethodDescription();
        }
    }

    function toggleShippingMethodDescription() {
        $('.osc-shipping-method-desc').addClass('hidden');
        $('.osc-shipping-method-additional-infos').addClass('hidden');
        $("input[id^='s_method']").each(function () {
            if ($(this).is(':checked')) {
                $('#desc_method_' + $(this).val()).removeClass('hidden');
                $('#additional_infos_method_' + $(this).val()).removeClass('hidden');
            }
        });
    }

    function setHeightIframe(ifr, ifr_selector) {
        var _self = this,
            _time = 0,
            _ifr = document.getElementById(ifr_selector);
        if (typeof ifr === 'undefined' || ifr === null || typeof _ifr === 'undefined' || _ifr === null) return;
        var ifr_height = _ifr.getAttribute('height'),
            _content = _ifr.contentWindow;
        if (typeof _content === 'undefined' || _content === null || _content.document.body === null) return;
        var _content_temp = $(_content.document.body).height();
        if (typeof _content_temp !== 'undefined') {
            $('.gallery-placeholder', $(_content.document.body)).trigger('contentUpdate');
            if (ifr.height() !== _content_temp) {
                ifr.height(_content_temp);
            }
        }
        if (_time == 'undefined') _time = 0;
        clearTimeout(_time);
        _time = setTimeout(function () {
            _self.setHeightIframe(ifr);
        }, 500);
    }

    function sliderItemImages() {
        if ($('.item-images').length) {
            require(["jquery", "swiper"], function ($, Swiper) {
                var swiperItemImages = new Swiper('.item-images', {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    watchSlidesVisibility: true,
                    spaceBetween: 0,
                    watchOverflow: true,
                    pagination: {
                        el: '.item-images .swiper-pagination',
                        type: 'bullets',
                    },
                });
            });
        }
    }

    function calcColoris() {
        $(".product-item .product-color-wrap").each(function () {
            var width = $(this).width();
            var visibleItems = Math.trunc(width / 34);
            var id = $(this).attr('id');
            var numItems = $(this).find('.product-color-wrapper').length;
            if (numItems > visibleItems) {
                $(this).css('padding-right', '30px');
                $(this).find('.show-more-product-colors').css('display', 'block');
            }
        });
    }

    function calcColorisByProduct() {
        var $this = $(".bloc-associated .product-color-wrap");
        var width = $this.width();
        var visibleItems = Math.trunc(width / 28);
        var numItems = $this.find('.product-color-wrapper').length;
        if (numItems > visibleItems) {
            $this.css('padding-right', '30px');
            $this.find('.show-more-product-colors-btn').css('display', 'block');
        }
    }

    /**
     * Wait for element to exist in dom
     * @param selector
     * @param callback
     */
    function waitForElement(selector, callback) {
        var MuObserver = new MutationObserver(() => {
            if (document.querySelectorAll(selector).length) {
                callback();
                MuObserver.disconnect();
            }
        });
        MuObserver.observe(document.documentElement, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true
        });
    }

    /**
     * Load social login
     */
    function loadSocialLogin(callBack = false) {
        var $body = $('body');
        if (!$body.hasClass('ax-social-login-page-wrapper')) {
            $body.addClass('ax-social-login-page-wrapper');
            $.when($.ajax({
                url: url.build('social-login/sociallogin/index'),
                showLoader: true
            })).then(function (response) {
                $.when($('body').append(response)).then(function (response) {
                    var $amSocialLoginPopup = $("[data-am-js='am-login-popup']");
                    try {//catch for apply binding multiple times
                        if ($.fn.applyBindings != undefined) {
                            $amSocialLoginPopup.applyBindings();
                            $amSocialLoginPopup.trigger('contentUpdated');
                        }
                    } catch (e) {

                    }
                    waitForElement('.ax-social-login-page-wrapper.ax-social-loaded', function () {
                        callBack();
                    });
                });
            }, function (err) {
                console.error(err)
            });
        } else {
            var $amSocialLoginPopup = $("[data-am-js='am-login-popup']");
            try {//catch for apply binding multiple times
                if ($.fn.applyBindings != undefined) {
                    $amSocialLoginPopup.applyBindings();
                    $amSocialLoginPopup.trigger('contentUpdated');
                }
            } catch (e) {

            }
            callBack();
        }
    }

    function closeList() {
        var numOfOptions = $('.selectLabel .options>li').length;
        for (var i = 0; i < numOfOptions; i++) {
            $('.selectLabel .options').children('li').eq(i).css(
                'transform', 'translateY(' + i * 0 + 'px)').css('transition-delay', i * 0 + 'ms');
        }
    }

    // open-list and close-list items functions
    function openList() {
        var numOfOptions = $('.selectLabel .options>li').length;
        for (var i = 0; i < numOfOptions; i++) {
            $('.selectLabel .options').children('li').eq(i).attr('tabindex', i).css(
                'transform', 'translateY(' + (i * 100 + 100) + '%)').css(
                'transition-delay', i * 30 + 'ms');
        }
    }

    function elementInViewport2(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) && left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    function generateReviewPopupHtml(images, product) {
        let clientsImagesHtml = "";
        let imagesArray = typeof images !== "undefined" ? images : '[]';
        var clientsImages = JSON.parse(imagesArray);
        if (clientsImages.length > 0) {
            clientsImagesHtml += `<div class="carousel-avis carousel" data-flickity='{"lazyLoad": 1, "wrapAround": true, "contain": true, "pageDots": false, "cellAlign": "center"}'>`;
            clientsImages.forEach(image => {
                let webpSrc = image.includes('?') ? image + '&twic=v1&fm=webp' : image + '?twic=v1&fm=webp';
                clientsImagesHtml +=
                    `<div class="carousel-cell">
                    <picture>
                        <source srcset="${webpSrc}/quality=90" type="image/webp">
                        <img src="${image}?twic=v1/quality=90" width="700" height="700" alt="image">
                    </picture>
                </div>`;
            });
            clientsImagesHtml += `</div>`;
        }

        var btnLabel = $t('I want it !');
        var pictureHtml = `<div class="col-md-6">${clientsImagesHtml}</div>`;
        var html = `<div class="row align-items-center">`;
        html += `${pictureHtml}`;
        html += `<div class="col-md-6 mb-5 mb-md-0">`;
        if (typeof product.label !== 'undefined' && ($(window).width() > 767)) {
            html += `<div class="ax-product-label mb-3 mb-md-5">${product.label}</div>`;
        }

        let productWebpSrc = product.image.includes('?') ? product.image + '&twic=v13&fm=webp' : product.image + '?twic=v12&fm=webp';

        html += `
        <picture class="ax-product-item-photo mx-5 mt-4">
            <source srcset="${productWebpSrc}" type="image/webp">
            <img src="${product.image}" width="240" height="240" alt="image">
        </picture>`;
        html += `<div class="ax-product-name mb-3 my-md-5">${product.name}</div>`;
        html += `<div class="btn-block">`;
        html += `<a href="${product.url}" class="button-red action-btn">${btnLabel}<a/>`;
        html += `</div>`;
        html += `</div>`;
        return html;
    }
    function generateReviewImagePopupHtml(images) {
        let clientsImagesHtml = "";
        let imagesArray = typeof images !== "undefined" ? images : '[]';
        var clientsImages = JSON.parse(imagesArray);

        if (clientsImages.length > 0) {
            let firstImage = clientsImages[0];
            let webpSrc = firstImage.includes('?') ? firstImage + '&twic=v1&fm=webp' : firstImage + '?twic=v1&fm=webp';

            clientsImagesHtml = `
            <div class="bloc-img" >

                    <picture>
                        <source srcset="${webpSrc}/quality=90" type="image/webp">
                        <img src="${firstImage}?twic=v1/quality=90" width="600" height="600" alt="image">
                    </picture>

            </div>`;
        }

        var pictureHtml = `<div class="col-md-12">${clientsImagesHtml}</div>`;
        var html = `<div class="row align-items-center">`;
        html += `${pictureHtml}`;
        return html;
    }


    function swiperClientsReviewImagesInitialize() {
        require(['require', 'flickity'], function(require, Flickity) {
            var flickityAvis = new Flickity('.carousel-avis', {
                cellAlign: 'left',
                pageDots: true,
                lazyLoad: 1,
            });
            return flickityAvis
        });
    }

    try {
        if (window.screen.width < 1024) {

            $(document).on('click', '.search-action-close', function () {
                allowScroll();
            });

            $(document).on('click', function (event) {
                if (!$(event.target).closest('.ax_search_popup_area').length) {
                    allowScroll();
                }
            });
        }
    } catch (e) {
        console.log(e);
    }

});


function appendParameter(url, param) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + param;
}
;
